import { useEffect, useState } from 'react';
import LotusMark from './LotusMark.jsx';
import { DONATE_URL } from '../support.js';

const links = [
  ['/our-story', 'Our Story'],
  ['/board', 'Board'],
  ['/pillars', 'The Seven Pillars'],
  ['/wellness-week', 'Wellness Week'],
  ['/project-cambodia', 'Project Cambodia'],
  ['/partner', 'Partner'],
];

export default function Header({ path, darkAtTop = false }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setOpen(false), [path]);

  return (
    <header className={`site-header ${darkAtTop && !scrolled ? 'site-header--inverse' : ''} ${scrolled ? 'site-header--scrolled' : ''}`}>
      <div className="site-header__inner shell">
        <a className="brand" href="/" aria-label="Transformational Wellness home">
          <LotusMark className="brand__mark" />
          <span><strong>Transformational</strong><em>Wellness</em></span>
        </a>
        <button className="menu-toggle" type="button" aria-expanded={open} aria-controls="site-nav" onClick={() => setOpen((value) => !value)}>
          <span /><span /><span /><span className="sr-only">{open ? 'Close menu' : 'Menu'}</span>
        </button>
        <nav id="site-nav" className={`site-nav ${open ? 'site-nav--open' : ''}`} aria-label="Main navigation">
          {links.map(([href, label]) => <a key={href} className={path === href ? 'is-active' : ''} href={href} aria-current={path === href ? 'page' : undefined}>{label}</a>)}
          <a className="button button--gold button--small" href={DONATE_URL} target="_blank" rel="noopener noreferrer">Donate</a>
        </nav>
      </div>
    </header>
  );
}
